import api from '@/js/services/api';
export default {
    deleteCallOut(id) {
        return api().delete(`/master-admin/call-out/` + id + `/delete`);
    },
    exportCallOutsData(dataToSend) {
        return api().post('/master-admin/call-out/export', dataToSend, {responseType: 'blob'})
    },
    getCallOutInfo(filters) {
        const searchParams = new URLSearchParams();

        for (const [key, value] of Object.entries(filters)) {
            searchParams.append(key, value)
        }

        return api().get('/master-admin/call-out/get?' + searchParams.toString())
    },

    updateCallOut(id, form) {
        return api().put('/master-admin/call-out/' + id + '/update', form)
    },

    saveNewCallOut(form) {
        return api().post(`/master-admin/call-out/store`, form);
    },



}
